import { useState, useEffect } from 'react';
import { medicalCenterService } from '../services/medicalCenterService';

export function usePrograms(medicalCenterId) {
  const [programs, setPrograms] = useState([]);
  const [selectedProgramId, setSelectedProgramId] = useState('');

  useEffect(() => {
    const loadPrograms = async () => {
      if (!medicalCenterId) return;
      const mc = await medicalCenterService.getMedicalCenter(medicalCenterId);
      const data = mc?.programs || [];
      setPrograms(data);
    };
    loadPrograms();
  }, [medicalCenterId]);

  return { programs, selectedProgramId, setSelectedProgramId };
}